if (!customElements.get('s-tech-details')) {
  customElements.define(
    's-tech-details',
    class TechDetailsLegacy extends HTMLElement {
      constructor() {
        super();
        this.openButton = this.querySelector('[data-open]');
        this.closeButtons = this.querySelectorAll('[data-close]');
        this.popup = this.querySelector('[data-popup]');
      }

      connectedCallback() {
        if (!this.popup || !this.openButton) return;
        this.openButton.addEventListener('click', () => this.open());
        if (!this.closeButtons.length) return;
        this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
      }

      open() {
        this.popup.classList.add('active-tech-details');
        this.closeButtons.forEach((button) => button.classList.add('active'));
      }

      close() {
        this.popup.classList.remove('active-tech-details');
        this.closeButtons.forEach((button) => button.classList.remove('active'));
      }
    },
  );
}
